import { AppNexusData } from '../../shared/types/ast';
import { requestBanners } from '../utils/banners';

export function copyQueue() {
    const { queue } = window.FINN.banner;
    const tempQueue = Array.isArray(queue) ? [...queue] : [];

    if (window.apntag) {
        window.FINN.banner.queue = window.apntag.anq;
        const { anq } = window.apntag;
        tempQueue.forEach((element) => anq.push(element));
    }
}

export function mockPodlet(appNexusData: AppNexusData) {
    const { apntag } = window;
    if (apntag) {
        apntag.debug = true;
        window.FINN = window.FINN || ({} as any);
        window.FINN.banner = window.FINN.banner || ({} as any);
        window.FINN.banner.debouncedLoadTags = apntag.loadTags;
        requestBanners(apntag, appNexusData, false, true, false);
        copyQueue();
    }
}
